export default "__VITE_ASSET__EtvaVy43__"